import { parsePhoneNumberFromString } from 'libphonenumber-js';

import type { StandbyWaitlistJoinPayload } from '@/api/standby/standbyWaitlistJoinMutation/types';
import type { CartItem, Service } from '@/types/booking';
import { transformServiceIds } from '@/utils/bookingCartUtils';
import { getApiPlatform } from '@/utils/getPlatform';
import type { WaitlistTimePreference } from '@/utils/waitlistTimePreferences';

interface StandbyWaitlistSelection {
  barberId: string;
  day: string;
  timePreferences: WaitlistTimePreference[];
}

interface BuildStandbyWaitlistJoinPayloadInput {
  shopId: string;
  customer: {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
  };
  cartItem: CartItem;
  selection: StandbyWaitlistSelection;
  services?: Service[];
  language: string;
}

export const buildStandbyWaitlistJoinPayload = ({
  shopId,
  customer,
  cartItem,
  selection,
  services,
  language,
}: BuildStandbyWaitlistJoinPayloadInput): StandbyWaitlistJoinPayload => {
  const phone = customer.phone;
  const requestedBarberId =
    selection.barberId && !cartItem.bookedWithAnyBarber
      ? selection.barberId
      : undefined;

  return {
    shopId,
    firstName: customer.firstName.trim(),
    lastName: customer.lastName.trim(),
    phone: parsePhoneNumberFromString(phone)?.number ?? phone,
    email: customer.email.trim(),
    preferredLanguage: language,
    ...(requestedBarberId ? { requestedBarberId } : {}),
    scheduledFor: selection.day,
    serviceIds: transformServiceIds(
      cartItem.services.map((service) => service.id),
      services,
    ),
    timePreferences: selection.timePreferences,
    platform: getApiPlatform(),
  };
};
